<template>
    <v-flex d-flex fill-height>
        <v-layout column class="event-messages">
            <message-form ref="messageForm" :eventId="eventId"
                          :conversation="conversation"></message-form>
            <v-flex fill-height column class="messages" :class="messageCategories[conversation.type].color">
                    <v-lazy v-for="(message, index) in messages"
                            :key="message.id" min-height="40" class="flex-shrink-0">
                        <message v-bind:unvisited="messages"
                                 v-bind:previous="previous(index)"
                                 v-bind:next="next(index)"
                                 v-bind:isNew="isNew"
                                 v-bind:message="message"
                                 v-bind:conversation="conversation"
                                 v-bind="message"/>
                    </v-lazy>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>

import {mapGetters, mapState} from 'vuex'
import MessageForm from './MessageForm'
import Message from './Message'
import {appBus} from "@/main";
import {OPEN_MESSAGE_CONTEXT, SCROLL_TO_MESSAGE_AND_OPEN_CONTEXT} from "@/events";

export default {
    name: 'sidebar-event-messages',
    components: {
        MessageForm,
        Message,
    },
    data() {
        return {
            isNew: false,
        }
    },
    updated() {
        this.isNew = true;
    },
    props: {
        eventId: {
            type: Number,
            required: true,
        },
        conversation: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters('messages', {
            unvisitedByEvent: 'unvisitedByEvent',
            eventMessages: 'eventMessages',
        }),
        ...mapState({
            messageCategories: state => state.messages.categories,
            event: state => state.events.local[state.events.active],
        }),
        unvisited() {
            return this.unvisitedByEvent(this.event, this.conversation.id);
        },
        messages() {
            return this.eventMessages(this.conversation.id);
        },
    },
    created() {
        appBus.$on(SCROLL_TO_MESSAGE_AND_OPEN_CONTEXT, (messageId) => {
            this.scrollToMessage(messageId);
        });
    },
    methods: {
        scrollToMessage(messageId) {
            const message = this.messages.find(msg => msg.id === messageId);
            if (!message) {
                console.warn('Message not found in current category:', messageId);
                return;
            }
            this.$nextTick(() => {
                const messageElements = document.querySelectorAll('.v-message');
                for (const element of messageElements) {
                    if (element.querySelector('.sequence') &&
                        element.querySelector('.sequence').textContent.includes(`(${message.sequence})`)) {
                            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            // setTimeout(() => {
                            //     appBus.$emit(OPEN_MESSAGE_CONTEXT, messageId);
                            // }, 200);
                        }
                }
            });
        },
        previous(index) {
            let messages = this.messages;
            if (index < messages.length)
                return messages[index - 1];

            return null;
        },
        next(index) {
            let messages = this.messages;
            if (index >= 0 && index < messages.length - 1)
                return messages[index + 1];

            return null;
        },
    },
    beforeDestroy() {
        appBus.$off(SCROLL_TO_MESSAGE_AND_OPEN_CONTEXT);
    }
}
</script>
